import LogRouteAnalyzeReducer from 'store/log/route-analyze/reducers';

export default LogRouteAnalyzeReducer;
